export const IDLE = 'idle';
export const PENDING = 'pending';
export const SUCCEEDED = 'succeeded';
export const FAILED = 'failed';

export const ALL_RESOURCES = 'all';
